import React from 'react';
import { Title, Container, Selection as SelectionMenu } from "./Selection.styles";
var Selection = function Selection(props) {
  var dataTest = props.dataTest,
    title = props.title,
    items = props.items,
    selectedIndex = props.selectedIndex,
    onItemClick = props.onItemClick;
  return /*#__PURE__*/React.createElement(Container, {
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Title, {
    id: dataTest
  }, title), /*#__PURE__*/React.createElement(SelectionMenu, {
    size: 'lg',
    "aria-labelledby": dataTest,
    menuDirection: 'horizontal',
    items: items,
    activeItemIndex: selectedIndex,
    onItemClick: onItemClick
  }));
};
export default Selection;